import script from "./NotesFiltersButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesFiltersButtons.vue?vue&type=script&setup=true&lang=js"

import "./NotesFiltersButtons.vue?vue&type=style&index=0&id=532bb6b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532bb6b4"]])

export default __exports__